// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import {
  EventItemFragmentDoc,
  ReceiptItemFragmentDoc,
  AnnotationItemFragmentDoc,
  LedgerCategoryInfoItemFragmentDoc,
} from '../../common-client-queries.generated';
export type DeleteReceiptMutationVariables = Types.Exact<{
  eventFid: Types.Scalars['ID'];
  receiptFid: Types.Scalars['ID'];
}>;

export type DeleteReceiptMutation = {
  readonly __typename: 'Mutation';
  readonly deleteReceipt: {
    readonly __typename: 'Event';
    readonly fid: string;
    readonly dateTime: string;
    readonly movementType: Types.MovementType;
    readonly title: string;
    readonly description: string;
    readonly subtitle: string | null;
    readonly infoLine: string | null;
    readonly icon: string | null;
    readonly bulkPaymentFid: string | null;
    readonly currencyAmount: string | null;
    readonly currencyCode: string | null;
    readonly amount: string | null;
    readonly physicalTerminal: boolean;
    readonly isInvoice: boolean;
    readonly isOwnCardEvent: boolean;
    readonly completed: boolean;
    readonly isEditable: boolean;
    readonly card: {
      readonly __typename: 'Card';
      readonly fid: string;
      readonly name: string | null;
    } | null;
    readonly account: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly name: string;
    } | null;
    readonly transaction: {
      readonly __typename: 'EventTransaction';
      readonly fid: string;
      readonly remittanceInformation: string | null;
      readonly debtorAccountNumber: string | null;
      readonly creditorAccountNumber: string | null;
      readonly kid: string | null;
      readonly bookingDate: string | null;
      readonly isPending: boolean;
    } | null;
    readonly payment: {
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly status: Types.PaymentStatus;
      readonly kid: string | null;
      readonly message: string | null;
      readonly debtorAccount: string;
      readonly creditorAccount: string;
      readonly isTaxPayment: boolean;
      readonly external: boolean;
      readonly fee: string | null;
      readonly createdBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly signedBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly accountingSystemInformation: {
        readonly __typename: 'AccountingSystemPaymentInformation';
        readonly systemName: string;
        readonly ledgerAccount: number | null;
        readonly externalURL: string | null;
      } | null;
    } | null;
    readonly merchant: {
      readonly __typename: 'Merchant';
      readonly fid: string;
      readonly name: string;
    } | null;
    readonly receipts: ReadonlyArray<{
      readonly __typename: 'Receipt';
      readonly fid: string;
      readonly mime: string;
      readonly uploadedAt: string;
      readonly userData: string | null;
      readonly isInvoice: boolean;
      readonly receiptLooksValid: boolean;
      readonly images: {
        readonly __typename: 'ReceiptImages';
        readonly color: string;
        readonly originalUrl: string;
        readonly croppedUrl: string | null;
        readonly thumbnail128Url: string | null;
        readonly thumbnail256Url: string | null;
        readonly thumbnail512Url: string | null;
      };
    }>;
    readonly note: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly purpose: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly participants: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly receiptNotNeeded: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly receiptLost: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly requirements: {
      readonly __typename: 'EventRequirements';
      readonly metRequirementCount: number;
      readonly totalRequirementCount: number;
      readonly allRequirementsMet: boolean;
      readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
      readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
      readonly requirementsOverridden: {
        readonly __typename: 'RequirementsOverriddenInfo';
        readonly overridden: boolean;
        readonly accountingSystem: string | null;
      };
    };
    readonly ledgerCategoryInfo: {
      readonly __typename: 'LedgerCategoryInfo';
      readonly kind: Types.LedgerCategoryInfoKind;
      readonly category: {
        readonly __typename: 'LedgerCategoryItem';
        readonly fid: string;
        readonly title: string;
        readonly subtitle: string | null;
        readonly icon: Types.LedgerCategoryIcon;
        readonly synonyms: ReadonlyArray<string>;
        readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
      } | null;
      readonly guesses: ReadonlyArray<{
        readonly __typename: 'LedgerCategoryItem';
        readonly fid: string;
      }>;
    };
  };
};

export type DeleteStandaloneReceiptMutationVariables = Types.Exact<{
  receiptFid: Types.Scalars['ID'];
}>;

export type DeleteStandaloneReceiptMutation = {
  readonly __typename: 'Mutation';
  readonly deleteStandaloneReceipt: boolean;
};

export const DeleteReceiptDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteReceipt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eventFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'receiptFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteReceipt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'eventFid' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiptFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'receiptFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EventItem' },
                },
              ],
            },
          },
        ],
      },
    },
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  DeleteReceiptMutation,
  DeleteReceiptMutationVariables
>;
export const DeleteStandaloneReceiptDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteStandaloneReceipt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'receiptFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteStandaloneReceipt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiptFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'receiptFid' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteStandaloneReceiptMutation,
  DeleteStandaloneReceiptMutationVariables
>;
